/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ButtonMenuIcon from 'DesignSystem/ButtonMenuIcon/index'
import React from 'react'
import TysiaIconDevelopers from 'DesignSystem/Svgs/TysiaIconDevelopers/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Menu/Content/IconsAction/Content",
  isSelected
  
}) {
let tabSelectedTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.tab',
})
let constantData = 'icons'
let aggregateData = fromAggregate.equals(tabSelectedTabValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected
  
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<ButtonMenuIcon
  viewPath={`${viewPath}/ButtonMenuIcon`}
 marginRight={0}
 text="Icons"
 onClick={onClick}
 data="tab.selected.tab"
 data="'icons'"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
>
{childProps => (
<TysiaIconDevelopers
{...childProps}
  viewPath={`${viewPath}/TysiaIconDevelopers`}
 width={16}
 height={16}
 stroke={childProps.isSelected ? dtColorsGreen700 : dtColorsNeutral900}
/>
)}
</ButtonMenuIcon>
{children}
</React.Fragment>)
}